<div class="h-100">
  <table class="table table-responsive-md table-borderless ">
    <tbody>
      @for (item of waitingListData; track $index) {
      <tr (click)="viewPatientDetails(item)" style="cursor: pointer;" class="selectPatient">
        <!-- <td>
          <span>
            <strong>{{item.patientName}}</strong><br>
            <small>
              <b>{{item?.patient_id}}</b>
            </small>
          </span>
        </td>
        <td>
          <p class="badge badge-info">T:{{item.token_no}}</p>
        </td>
        <td>
          <p class="text-muted">{{item?.doctorName || 'Admin'}}</p>
        </td> -->
        <div [ngClass]="{ 'next-token text-light':item.status == 3}"
          class="d-flex list-patient justify-content-between">
          <div>
            <strong>{{item.patientName}} - <small style="font-weight: 500">{{item?.patient_id}}</small></strong><br>
            <small>{{item?.doctorName || 'Admin'}}</small>
          </div>
          <div>
            <p class="badge badge-info mb-1">{{item.token_no}}</p><br>
            <small>{{item.counterName}}</small>
          </div>
        </div>
      </tr>
      }
    </tbody>
  </table>
</div>

<!-- <div class="offcanvas offcanvas-end" tabindex="-1" id="offcanvasLeft" aria-labelledby="offcanvasLeftLabel">
  <div class="offcanvas-header">
    <h5 class="offcanvas-title" id="offcanvasLeftLabel">Offcanvas right</h5>
    <button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
  </div>
  <div class="offcanvas-body">
    ...
  </div>
</div> -->